var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "currentFill"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1875 16.25V24.3167C25.1875 25.3434 25.1875 25.8569 24.9948 26.249C24.8254 26.5939 24.5549 26.8744 24.2223 27.0502C23.8441 27.25 23.349 27.25 22.3589 27.25H15.6411C14.651 27.25 14.1559 27.25 13.7778 27.0502C13.4451 26.8744 13.1747 26.5939 13.0052 26.249C12.8125 25.8569 12.8125 25.3434 12.8125 24.3167V13.6833C12.8125 12.6566 12.8125 12.1432 13.0052 11.751C13.1747 11.406 13.4451 11.1256 13.7778 10.9498C14.1559 10.75 14.651 10.75 15.6411 10.75H19.8839M25.1875 16.25L19.8839 10.75M25.1875 16.25H20.7679C20.2797 16.25 19.8839 15.8396 19.8839 15.3333V10.75",
    stroke: "currentColor",
    strokeWidth: 1.28906,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesIcon);
export default __webpack_public_path__ + "static/media/FilesIcon.b53446785bee4a7ef7e050fcc657a18f.svg";
export { ForwardRef as ReactComponent };